
import { types, explanations } from '../shared/ordercontrolrestrictions';

export const restrictions = [
    {
        type: types.idCustomerInState,
        state: ['California'],
        id: [15189],
        message: explanations.notInArea
    },
    {
        type: types.idCustomerNotInState,
        state: ['Michigan', 'Indiana', 'Kentucky', 'North Carolina', 'Virginia', 'West Virginia', 'Ohio', 'Pennsylvania', 'New Jersey', 'Maryland', 'New York', 'Connecticut', 'Rhode Island', 'Massachusetts', 'Vermont', 'New Hampshire', 'Maine', 'Delaware'],
        id: [21897, 21889, 22143],
        message: explanations.notInArea
    },
    {
        type: types.skuCustomerInState,
        state: ['California'],
        id: [2109664833, 2109701194, 2109664831, 2109783784],
        message: explanations.notInArea
    }
];